import { Component, ElementRef, Input, OnChanges, ViewChild } from '@angular/core';
import { InjectConfig, ModelsExperienceConfigKey } from '@ddt-web/config-layer';
import { CellData, ComponentData, DataMap } from '@ddt-web/data-service';
import { distinctUntilChangedDeep } from '@ddt-web/generic-utils';
import { ApplicationStateStoreProxyService, PerformanceState } from '@ddt-web/shared-stores';
import * as flatten from 'lodash/flatten';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApplicationConstants } from '../../config';
import { MiniCompareDataPointsConfig, miniCompareTableData, MiniCompareTableDataConfig, miniCompareTableDataPointsList, miniCompareTableGrossDataPoints, ModelDropdown } from '../../models';

@Component({
	selector: 'mb-mini-compare-data-table',
	templateUrl: './mini-compare-data-table.component.html',
	styleUrls: ['./mini-compare-data-table.component.scss']
})
export class MiniCompareDataTableComponent implements OnChanges {
	@InjectConfig(ModelsExperienceConfigKey.ENABLE_ADD_TO_COMPARE_MODEL) public readonly enableAddToCompareModel: boolean = false;

	@Input() public data: ComponentData;
	@Input() public selectedPortfolios: ModelDropdown[];
	@Input() public showOptionalData: boolean;
	public compareDataList: MiniCompareDataPointsConfig = miniCompareTableDataPointsList;
	public grossCompareDataList: MiniCompareDataPointsConfig = miniCompareTableGrossDataPoints;
	public compareDataConfig: MiniCompareTableDataConfig = miniCompareTableData;
	public ApplicationConstants: ApplicationConstants = ApplicationConstants;
	public compareData: Array<DataMap<CellData>> = [];
	public customAdvisoryFee$: Observable<number>;
	@ViewChild('benchmarkDisclosure') public benchmarkDisclosureRef: ElementRef;

	constructor(private applicationStateStoreProxyService: ApplicationStateStoreProxyService) { }

	public ngOnChanges(): void {
		this.customAdvisoryFee$ = this.applicationStateStoreProxyService.getPerformanceState()
			.pipe(
				distinctUntilChangedDeep(),
				map((state: PerformanceState) => state?.customAdvisoryFee)
			);

		if (this.data.success) {
			const miniCompareData = flatten(this.data.getTabById('mini.compare.data')?.tableData?.map(tableData => tableData['rows'])) || [];
			this.compareData = [];
			this.selectedPortfolios.forEach(portfolio => {
				this.compareData.push(miniCompareData.find(model => model.id?.formattedValue === portfolio.modelId) || []);
			});
		}
	}

	public scrollToBenchmarkDisclosure(index): void {
		const element = this.benchmarkDisclosureRef.nativeElement.querySelector(`#performance-benchmark-disclosure-${index}`);
		element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
	}
}
